// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailVerificationView_container__G9rlt"};